import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Identificar los celos sin asustarme",
    opening: localizedGenderNode(
      [
      "Hoy no intento estar “por encima de esto”. Identifico los celos — y me quedo conmigo.",
      "Me detengo conmigo."
    ],
      [
      "Hoy no intento estar “por encima de esto”. Identifico los celos — y me quedo conmigo.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración lenta.",
      "Me digo por dentro: “Esto es dolor y celos. No son una orden.”"
    ],
      [
      "Una respiración lenta.",
      "Me digo por dentro: “Esto es dolor y celos. No son una orden.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura — para mí\nMe pregunto:\n¿Qué siento ahora cuando aparece la imagen/el pensamiento de mi ex con otra persona? (una o dos palabras)",
      "Me pregunto:\n¿En qué parte del cuerpo lo siento? (pecho/estómago/garganta/cabeza)",
      "Me pregunto:\n¿Qué es lo que más “quema” dentro de esto? (reemplazo? rechazo? comparación? miedo?)"
    ],
      [
      "Escritura — para mí\nMe pregunto:\n¿Qué siento ahora cuando aparece la imagen/el pensamiento de mi ex con otra persona? (una o dos palabras)",
      "Me pregunto:\n¿En qué parte del cuerpo lo siento? (pecho/estómago/garganta/cabeza)",
      "Me pregunto:\n¿Qué es lo que más “quema” dentro de esto? (reemplazo? rechazo? comparación? miedo?)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Hoy no discuto con la emoción. La veo y respiro a su lado."
    ],
      [
      "Cierre",
      "Hoy no discuto con la emoción. La veo y respiro a su lado."
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparece un disparador — hago una “pausa de 30 segundos”: una respiración + una frase interna: “Es una ola. Pasa.”",
      "Cuando aparece un disparador — hago una “pausa de 30 segundos”: una respiración + una frase interna: “Es una ola. Pasa.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Historia vs. hecho (dejar de vivir en una película)",
    opening: localizedGenderNode(
      [
      "Hoy separo lo que sé de lo que mi mente dibuja.",
      "Me detengo conmigo."
    ],
      [
      "Hoy separo lo que sé de lo que mi mente dibuja.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “No tengo que creer cada imagen.”"
    ],
      [
      "Una respiración. “No tengo que creer cada imagen.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es el hecho concreto que sé? (2 líneas, sin interpretación)",
      "¿Qué película construye mi mente alrededor? (¿qué imagino que significa?)",
      "¿Qué le hace a mi cuerpo cuando creo esa película?",
      "¿Qué verdad suave puedo elegir hoy en lugar de la película? (una frase)"
    ],
      [
      "Escritura\n¿Cuál es el hecho concreto que sé? (2 líneas, sin interpretación)",
      "¿Qué película construye mi mente alrededor? (¿qué imagino que significa?)",
      "¿Qué le hace a mi cuerpo cuando creo esa película?",
      "¿Qué verdad suave puedo elegir hoy en lugar de la película? (una frase)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No todo pensamiento es verdad. A veces es solo ansiedad buscando control."
    ],
      [
      "Cierre",
      "No todo pensamiento es verdad. A veces es solo ansiedad buscando control."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy digo: “Esto es una historia. Vuelvo a los hechos.” Y luego una respiración.",
      "Una vez hoy digo: “Esto es una historia. Vuelvo a los hechos.” Y luego una respiración."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Impulso de revisar/mirar (protocolo de 90 segundos)",
    opening: localizedGenderNode(
      [
      "Hoy creo una pausa antes de actuar, para que los celos no me manejen.",
      "Me detengo conmigo."
    ],
      [
      "Hoy creo una pausa antes de actuar, para que los celos no me manejen.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Me elijo a mí primero.”"
    ],
      [
      "Una respiración. “Me elijo a mí primero.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué impulso aparece hoy? (mirar/revisar/buscar/escribir)",
      "¿Qué intento calmar de verdad con este impulso? (incertidumbre? dolor? miedo al abandono? humillación?)",
      "Protocolo de 90 segundos (desde hoy)\n\n1. 3 respiraciones lentas\n\n\n2. Observar el cuerpo: ¿dónde se siente el impulso?\n\n\n3. Una frase interna: “Es un impulso. Pasará.”\nLuego elijo una alternativa pequeña.\n\n\n\n¿Qué alternativa elijo hoy en lugar de revisar?"
    ],
      [
      "Escritura\n¿Qué impulso aparece hoy? (mirar/revisar/buscar/escribir)",
      "¿Qué intento calmar de verdad con este impulso? (incertidumbre? dolor? miedo al abandono? humillación?)",
      "Protocolo de 90 segundos (desde hoy)\n\n1. 3 respiraciones lentas\n\n\n2. Observar el cuerpo: ¿dónde se siente el impulso?\n\n\n3. Una frase interna: “Es un impulso. Pasará.”\nLuego elijo una alternativa pequeña.\n\n\n\n¿Qué alternativa elijo hoy en lugar de revisar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No necesito actuar para calmarme. También puedo calmarme sin acción."
    ],
      [
      "Cierre",
      "No necesito actuar para calmarme. También puedo calmarme sin acción."
    ]
    ),
    action: localizedGenderNode(
      "Cada vez que aparece un impulso — hago el protocolo de 90 segundos una sola vez.",
      "Cada vez que aparece un impulso — hago el protocolo de 90 segundos una sola vez."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La comparación (recuperar valor propio)",
    opening: localizedGenderNode(
      [
      "Hoy dejo de medirme contra otra persona.",
      "Me detengo conmigo."
    ],
      [
      "Hoy dejo de medirme contra otra persona.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “La comparación es dolor disfrazado de verdad.”"
    ],
      [
      "Una respiración. “La comparación es dolor disfrazado de verdad.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿En qué me comparo? (belleza/edad/dinero/facilidad/seguridad/estatus)",
      "¿Qué me digo que eso significa sobre mí?",
      "¿Qué otra verdad existe sobre mí, aunque ahora no la sienta? (una frase)",
      "¿Qué fuerza/valor en mí no depende de nadie?"
    ],
      [
      "Escritura\n¿En qué me comparo? (belleza/edad/dinero/facilidad/seguridad/estatus)",
      "¿Qué me digo que eso significa sobre mí?",
      "¿Qué otra verdad existe sobre mí, aunque ahora no la sienta? (una frase)",
      "¿Qué fuerza/valor en mí no depende de nadie?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Mi valor no desaparece porque apareció otra persona."
    ],
      [
      "Cierre",
      "Mi valor no desaparece porque apareció otra persona."
    ]
    ),
    action: localizedGenderNode(
      "Escribo 3 cualidades/valores que son solo míos — y los guardo en mi diario.",
      "Escribo 3 cualidades/valores que son solo míos — y los guardo en mi diario."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "La vergüenza (la sensación de “me reemplazaron”)",
    opening: localizedGenderNode(
      [
      "Hoy toco la vergüenza sin dejar que me rompa.",
      "Me detengo conmigo."
    ],
      [
      "Hoy toco la vergüenza sin dejar que me rompa.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “La vergüenza quiere que me esconda. Hoy me quedo.”"
    ],
      [
      "Una respiración. “La vergüenza quiere que me esconda. Hoy me quedo.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es la frase más dura que escucho en mi cabeza? (“No fui suficiente…”, “Me reemplazaron…”)",
      "Si un amigo al que amo dijera esto sobre sí mismo — ¿qué le diría yo?",
      "¿Qué frase suave estoy dispuesto/a a decirme hoy en lugar de la vergüenza?",
      "¿Qué necesito ahora para sentirme un poco protegido/a?"
    ],
      [
      "Escritura\n¿Cuál es la frase más dura que escucho en mi cabeza? (“No fui suficiente…”, “Me reemplazaron…”)",
      "Si un amigo al que amo dijera esto sobre sí mismo — ¿qué le diría yo?",
      "¿Qué frase suave estoy dispuesto/a a decirme hoy en lugar de la vergüenza?",
      "¿Qué necesito ahora para sentirme un poco protegido/a?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La vergüenza no es verdad. Es una señal de que me duele."
    ],
      [
      "Cierre",
      "La vergüenza no es verdad. Es una señal de que me duele."
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparece la vergüenza — mano en el pecho/estómago (si se siente bien) + una sola frase suave.",
      "Cuando aparece la vergüenza — mano en el pecho/estómago (si se siente bien) + una sola frase suave."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Celos como dolor de vínculo (lo que me falta ahora)",
    opening: localizedGenderNode(
      [
      "Hoy entiendo que los celos señalan una necesidad.",
      "Me detengo conmigo."
    ],
      [
      "Hoy entiendo que los celos señalan una necesidad.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Los celos son una flecha que apunta a un lugar vacío.”"
    ],
      [
      "Una respiración. “Los celos son una flecha que apunta a un lugar vacío.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué me falta de verdad ahora? (calidez? pertenencia? seguridad? validación? contacto? futuro?)",
      "¿Cómo me gustaría recibir esto — en una versión limpia que no me dañe?",
      "¿Quién/qué puede darme parte de esto hoy? (persona segura/acción/rutina)",
      "¿Qué paso pequeño doy hoy para llenar una necesidad?"
    ],
      [
      "Escritura\n¿Qué me falta de verdad ahora? (calidez? pertenencia? seguridad? validación? contacto? futuro?)",
      "¿Cómo me gustaría recibir esto — en una versión limpia que no me dañe?",
      "¿Quién/qué puede darme parte de esto hoy? (persona segura/acción/rutina)",
      "¿Qué paso pequeño doy hoy para llenar una necesidad?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Los celos no tienen que llevarme a actuar hacia mi ex. Pueden llevarme hacia mí."
    ],
      [
      "Cierre",
      "Los celos no tienen que llevarme a actuar hacia mi ex. Pueden llevarme hacia mí."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una “conexión limpia”: una charla breve con alguien seguro / una caminata / música tranquila.",
      "Elijo una “conexión limpia”: una charla breve con alguien seguro / una caminata / música tranquila."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Exposición limpia (ACT suave) — sostener una imagen sin escapar",
    opening: localizedGenderNode(
      [
      "Hoy practico sostener un disparador un momento, sin revisar y sin hundirme.",
      "Me detengo conmigo."
    ],
      [
      "Hoy practico sostener un disparador un momento, sin revisar y sin hundirme.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Puedo estar con esto un minuto.”"
    ],
      [
      "Una respiración. “Puedo estar con esto un minuto.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es el disparador que más me activa? (foto/lugar/redes/canción/escena)",
      "Elijo una práctica de exposición limpia:\nUn minuto — dejo que la imagen esté en mi mente, sin acción. Solo respiración.\n\n¿Qué pasó después del minuto? (en el cuerpo/en los pensamientos)",
      "¿Qué aprendí sobre la ola? (¿de verdad “no pasa”? )"
    ],
      [
      "Escritura\n¿Cuál es el disparador que más me activa? (foto/lugar/redes/canción/escena)",
      "Elijo una práctica de exposición limpia:\nUn minuto — dejo que la imagen esté en mi mente, sin acción. Solo respiración.\n\n¿Qué pasó después del minuto? (en el cuerpo/en los pensamientos)",
      "¿Qué aprendí sobre la ola? (¿de verdad “no pasa”? )"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Me fortalezco no porque huí — sino porque me quedé."
    ],
      [
      "Cierre",
      "Me fortalezco no porque huí — sino porque me quedé."
    ]
    ),
    action: localizedGenderNode(
      "Solo un minuto. No más. Constancia > fuerza.",
      "Solo un minuto. No más. Constancia > fuerza."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Límites suaves (proteger el corazón)",
    opening: localizedGenderNode(
      [
      "Hoy pongo un límite pequeño que me protege, sin guerra.",
      "Me detengo conmigo."
    ],
      [
      "Hoy pongo un límite pequeño que me protege, sin guerra.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Un límite es protección, no castigo.”"
    ],
      [
      "Una respiración. “Un límite es protección, no castigo.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué límite me ayudará esta semana? (no revisar redes / no preguntar a amigos / no buscar información)",
      "¿Cuál es mi miedo si pongo este límite?",
      "¿Cuál es una respuesta suave a ese miedo?",
      "¿Cómo formulo el límite en primera persona? (“Esta semana no _ para protegerme”)"
    ],
      [
      "Escritura\n¿Qué límite me ayudará esta semana? (no revisar redes / no preguntar a amigos / no buscar información)",
      "¿Cuál es mi miedo si pongo este límite?",
      "¿Cuál es una respuesta suave a ese miedo?",
      "¿Cómo formulo el límite en primera persona? (“Esta semana no _ para protegerme”)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un límite protege un corazón herido. Es un acto de respeto propio."
    ],
      [
      "Cierre",
      "Un límite protege un corazón herido. Es un acto de respeto propio."
    ]
    ),
    action: localizedGenderNode(
      "Activo una acción que facilita el límite: ocultar/silenciar/eliminar un disparador.",
      "Activo una acción que facilita el límite: ocultar/silenciar/eliminar un disparador."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "“Ellos están felices y yo me quedé” (romper el mito)",
    opening: localizedGenderNode(
      [
      "Hoy dejo de leer la vida de otros desde una sola imagen.",
      "Me detengo conmigo."
    ],
      [
      "Hoy dejo de leer la vida de otros desde una sola imagen.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “No sé toda su historia.”"
    ],
      [
      "Una respiración. “No sé toda su historia.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué frase automática aparece? (“Están felices”, “Me desecharon”, “Soy menos”)",
      "¿Qué sé realmente y qué solo estoy suponiendo?",
      "¿Qué puedo construir para mí, aunque duela?",
      "¿Qué verdad sobre mi camino estoy dispuesto/a a recordar hoy?"
    ],
      [
      "Escritura\n¿Qué frase automática aparece? (“Están felices”, “Me desecharon”, “Soy menos”)",
      "¿Qué sé realmente y qué solo estoy suponiendo?",
      "¿Qué puedo construir para mí, aunque duela?",
      "¿Qué verdad sobre mi camino estoy dispuesto/a a recordar hoy?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Su imagen no define mi valor — ni mi futuro."
    ],
      [
      "Cierre",
      "Su imagen no define mi valor — ni mi futuro."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy — reemplazo la frase automática por una frase verdadera (la que escribí).",
      "Una vez hoy — reemplazo la frase automática por una frase verdadera (la que escribí)."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "La ira (sacarla sin destruirme)",
    opening: localizedGenderNode(
      [
      "Hoy dejo que la ira salga de una forma que me respeta.",
      "Me detengo conmigo."
    ],
      [
      "Hoy dejo que la ira salga de una forma que me respeta.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Tengo derecho a enojarme. No tengo derecho a dañarme.”"
    ],
      [
      "Una respiración. “Tengo derecho a enojarme. No tengo derecho a dañarme.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿De qué trata mi ira en realidad?",
      "¿Qué límite o valor intenta restaurar esta ira? (respeto/verdad/lealtad/seguridad)",
      "¿Cómo saco la ira sin revisar/atacar/humillarme? (acción física/escritura)",
      "¿Qué acción de respeto propio hago hoy desde la ira — y no contra mí?"
    ],
      [
      "Escritura\n¿De qué trata mi ira en realidad?",
      "¿Qué límite o valor intenta restaurar esta ira? (respeto/verdad/lealtad/seguridad)",
      "¿Cómo saco la ira sin revisar/atacar/humillarme? (acción física/escritura)",
      "¿Qué acción de respeto propio hago hoy desde la ira — y no contra mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La ira puede volverse una fuerza que me ordena, no una fuerza que me rompe."
    ],
      [
      "Cierre",
      "La ira puede volverse una fuerza que me ordena, no una fuerza que me rompe."
    ]
    ),
    action: localizedGenderNode(
      "10 minutos de movimiento (caminata rápida/ejercicio suave) — para sacar energía del cuerpo.",
      "10 minutos de movimiento (caminata rápida/ejercicio suave) — para sacar energía del cuerpo."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Recuperar control (tres cosas que sí están en mis manos)",
    opening: localizedGenderNode(
      [
      "Hoy reduzco el caos a un paso pequeño.",
      "Me detengo conmigo."
    ],
      [
      "Hoy reduzco el caos a un paso pequeño.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Un paso es suficiente.”"
    ],
      [
      "Una respiración. “Un paso es suficiente.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué me abruma más hoy sobre esto?",
      "¿Qué 3 cosas sí controlo hoy? (muy pequeñas)",
      "¿Qué paso único hago hoy?",
      "¿Qué cosa suelto hoy, aunque sea un poco?"
    ],
      [
      "Escritura\n¿Qué me abruma más hoy sobre esto?",
      "¿Qué 3 cosas sí controlo hoy? (muy pequeñas)",
      "¿Qué paso único hago hoy?",
      "¿Qué cosa suelto hoy, aunque sea un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre"
    ],
      [
      "Cierre"
    ]
    ),
    action: localizedGenderNode(
      "Acción pequeña para hoy",
      "Acción pequeña para hoy"
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "La noche y los bucles (cerrar el día)",
    opening: localizedGenderNode(
      [
      "Hoy le doy a mi mente un “cierre del día” para descansar.",
      "Me detengo conmigo."
    ],
      [
      "Hoy le doy a mi mente un “cierre del día” para descansar.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Esta noche no tengo que resolver.”"
    ],
      [
      "Una respiración. “Esta noche no tengo que resolver.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Cuál es mi bucle nocturno más común?",
      "¿Qué intenta lograr el bucle por mí? (control/respuesta/esperanza)",
      "¿Qué frase de cierre para la noche elijo? (una frase)",
      "¿Qué ritual de 3 minutos me ayuda antes de dormir?"
    ],
      [
      "Escritura\n¿Cuál es mi bucle nocturno más común?",
      "¿Qué intenta lograr el bucle por mí? (control/respuesta/esperanza)",
      "¿Qué frase de cierre para la noche elijo? (una frase)",
      "¿Qué ritual de 3 minutos me ayuda antes de dormir?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una mente cansada cuenta historias fuertes. Esta noche elijo descanso."
    ],
      [
      "Cierre",
      "Una mente cansada cuenta historias fuertes. Esta noche elijo descanso."
    ]
    ),
    action: localizedGenderNode(
      "Antes de dormir: mi frase de cierre + una respiración. Eso es todo.",
      "Antes de dormir: mi frase de cierre + una respiración. Eso es todo."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Convertir los celos en dirección (lo que construyo ahora)",
    opening: localizedGenderNode(
      [
      "Hoy los celos pasan de quemar — a ser una brújula.",
      "Me detengo conmigo."
    ],
      [
      "Hoy los celos pasan de quemar — a ser una brújula.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Lo que siento me dice qué es importante para mí.”"
    ],
      [
      "Una respiración. “Lo que siento me dice qué es importante para mí.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\n¿Qué me revelan los celos que deseo en mi vida? (relación? seguridad? amor? hogar?)",
      "¿Qué valor elijo para guiarme ahora? (respeto/verdad/calma/estabilidad)",
      "¿Qué hábito pequeño me acerca a ese valor esta semana?",
      "¿Qué me prometo cuando suba un disparador fuerte? (una frase)"
    ],
      [
      "Escritura\n¿Qué me revelan los celos que deseo en mi vida? (relación? seguridad? amor? hogar?)",
      "¿Qué valor elijo para guiarme ahora? (respeto/verdad/calma/estabilidad)",
      "¿Qué hábito pequeño me acerca a ese valor esta semana?",
      "¿Qué me prometo cuando suba un disparador fuerte? (una frase)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No tengo que quedarme en la comparación. Puedo construir una vida."
    ],
      [
      "Cierre",
      "No tengo que quedarme en la comparación. Puedo construir una vida."
    ]
    ),
    action: localizedGenderNode(
      "Planifico una cosa pequeña para la próxima semana que me devuelva futuro (encuentro/rutina/proyecto).",
      "Planifico una cosa pequeña para la próxima semana que me devuelva futuro (encuentro/rutina/proyecto)."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Ritual de soltar y cierre (quedarme conmigo)",
    opening: localizedGenderNode(
      [
      "Hoy cierro un capítulo sin borrarlo. Me devuelvo a mí.",
      "Me detengo conmigo."
    ],
      [
      "Hoy cierro un capítulo sin borrarlo. Me devuelvo a mí.",
      "Me detengo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Una respiración. “Suelto sin desaparecer.”"
    ],
      [
      "Una respiración. “Suelto sin desaparecer.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Escritura\nTres cosas que dejo de hacer para proteger mi corazón:",
      "Tres cosas que empiezo a hacer para construirme:",
      "Una carta breve que no se envía (5 líneas) — lo que quiero decir y luego soltar:",
      "Frase de regreso para días difíciles (una frase corta y clara):"
    ],
      [
      "Escritura\nTres cosas que dejo de hacer para proteger mi corazón:",
      "Tres cosas que empiezo a hacer para construirme:",
      "Una carta breve que no se envía (5 líneas) — lo que quiero decir y luego soltar:",
      "Frase de regreso para días difíciles (una frase corta y clara):"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del viaje",
      "No borro la emoción.",
      "Dejo de permitir que dirija mi vida.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fortaleza."
    ],
      [
      "Cierre final del viaje",
      "No borro la emoción.",
      "Dejo de permitir que dirija mi vida.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fortaleza."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una acción que simbolice “un capítulo nuevo”: un pequeño orden en casa / una caminata en un lugar nuevo / organizar el diario semanal.",
      "Elijo una acción que simbolice “un capítulo nuevo”: un pequeño orden en casa / una caminata en un lugar nuevo / organizar el diario semanal."
    ),
  },
].map(buildNormalizedDay);

export const jealousyExMovesOnBlueprintEs = buildNormalizedPilotBlueprint({
  id: "jealousy_ex_moves_on_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "jealousy_ex_moves_on",
  category: "general",
  journeyName: {
    he: "קנאה כשהאקס/ית ממשיכים הלאה",
    en: "Jealousy When an Ex Moves On",
    es: "Celos cuando el/la ex sigue adelante",
  },
  days,
});

export default jealousyExMovesOnBlueprintEs;
